// TODO: CL does not support null or undefined or empty string values correctly
export const NONE_SELECTED_VALUE = 'none-selected'
